import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    gray: Palette["primary"];
    whatsapp: Palette["primary"];
    white: Palette["primary"];
  }

  interface PaletteOptions {
    gray?: PaletteOptions["primary"];
    whatsapp?: PaletteOptions["primary"];
    white?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    gray: true;
    whatsapp: true;
    white: true;
  }
}

declare module "@mui/material/IconButton" {
  interface IconButtonPropsColorOverrides {
    gray: true;
    whatsapp: true;
    white: true;
  }
}

declare module "@mui/material/Fab" {
  interface FabPropsColorOverrides {
    gray: true;
    whatsapp: true;
    white: true;
  }
}

export const muiCustomTheme = createTheme({
  palette: {
    primary: {
      main: "#F23207",
    },
    secondary: {
      main: "#1F2A37",
    },
    gray: {
      light: "#FFEDEE",
      main: "#FFEEEF",
      dark: "#ECDCDD",
    },
    whatsapp: {
      light: "#25D366",
      main: "#25D366",
      dark: "#1D9F4C",
    },
    white: {
      light: "#ffffff",
      main: "#ffffff",
      dark: "#f0f0f0",
    },
  },
  typography: {
    fontFamily: "DM Sans, sans-serif",
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          letterSpacing: "-2%",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          letterSpacing: "-2%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          textTransform: "none",
          letterSpacing: "-2%",
          "&.MuiButton-sizeSmall": {
            borderRadius: "12px",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          "&.MuiInputBase-sizeSmall fieldset": {
            borderRadius: "12px",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: 12,
          },
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          backgroundColor: "#F6F8FB",
          padding: 6,
          gap: 22,
          boxSizing: "border-box",
          borderRadius: 12,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          border: "none",
          borderRadius: 12,
          textTransform: "inherit",
          backgroundColor: "transparent",
          color: "secondary",
          fontSize: "1rem",
          transition: "all 0.3s",
          "&.Mui-selected": {
            backgroundColor: "rgb(255,255,255)",
            color: "primary",
            borderRadius: 12,
          },
          "&.Mui-selected:hover": {
            backgroundColor: "rgb(255,255,255)",
            "&:active": {
              backgroundColor: "rgb(255,255,255)",
            },
          },
          "&:hover": {
            borderRadius: 12,
            backgroundColor: "rgba(255,255,255,0.5)",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&.MuiIconButton-colorWhite": {
            backgroundColor: "#ffffff",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid #E5E6E8",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          letterSpacing: "-2%",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#f9fafb",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "16px 20px",
        },
      },
    },
  },
});

export default { muiCustomTheme };
